// extracted by mini-css-extract-plugin
module.exports = {"container":"HistoryPatient_container__1OafG","header":"HistoryPatient_header__6y8xC","body":"HistoryPatient_body__wWvxS","box":"HistoryPatient_box__1uxQK"};